import { Invitation } from "@organizations/models";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";

export interface MyInvitationState extends EntityState<Invitation> {
  loading: boolean;
  loaded: boolean;
}

export const MyInvitationAdapter: EntityAdapter<Invitation> = createEntityAdapter<Invitation>({
  selectId: (invitation: Invitation) => invitation.id,
  sortComparer: (invitation1, invitation2) =>
    invitation1.roleName.localeCompare(invitation2.roleName)
});
